(function () {
    var root = document.getElementById('md-acc-orders-app');
    if (!root || typeof mdMealPrep === 'undefined') {
        return;
    }
    var M = window.MDMeals;
    if (!M || !M.api) {
        return;
    }

    function esc(s) {
        return M.esc(String(s == null ? '' : s));
    }
    function fmtMoney(n) {
        return '$' + Number(n || 0).toFixed(2);
    }
    function statusSlug(st) {
        return String(st || 'unknown').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }
    function statusClass(st) {
        return 'md-order-chip md-order-chip--' + statusSlug(st);
    }

    function pathTo(orderId) {
        // Honor pretty URLs when available; otherwise stick with ?order_id=.
        var base = (mdMealPrep && mdMealPrep.accountUrl) || '/account/';
        try {
            var u = new URL(base, window.location.origin);
            var p = u.pathname.replace(/\/?$/, '/') + 'orders/';
            if (orderId) p += orderId + '/';
            return p;
        } catch (e) {
            return base + 'orders/' + (orderId ? orderId + '/' : '');
        }
    }

    function renderList(orders, detailId) {
        if (!orders.length) {
            root.innerHTML =
                '<p class="md-empty-state">No orders yet. Open this week\'s menu to place one.</p>';
            return;
        }
        var h = '<ul class="md-orders-list md-orders-list--rich">';
        orders.forEach(function (o) {
            var active = detailId && String(o.id) === String(detailId);
            h +=
                '<li class="md-orders-list__item' + (active ? ' is-active' : '') +
                '"><a class="md-orders-list__link" href="' + esc(pathTo(o.id)) + '">';
            h += '<span class="' + statusClass(o.status) + '">' + esc(o.status || '') + '</span> ';
            if (o.payment_pill_html) { h += o.payment_pill_html + ' '; }
            h += '<span class="md-orders-list__title">' + esc(o.menu_title || 'Menu') + '</span>';
            if (o.menu_week_start) {
                h += ' <span class="md-orders-list__week">Week: ' + esc(o.menu_week_start) + '</span>';
            }
            h += '<span class="md-orders-list__meta">';
            h += (o.line_qty || 0) + ' items · ' + fmtMoney(o.total) + ' · ' + esc(o.fulfillment || '');
            h += '</span></a></li>';
        });
        h += '</ul>';
        root.innerHTML = h;
        root.setAttribute('aria-busy', 'false');
    }

    function renderDetail(o) {
        if (!o || !o.id) return '<p class="md-error">Order not found.</p>';
        var lines = '<ul class="md-order-detail-lines">';
        (o.line_items || []).forEach(function (li) {
            lines += '<li>' + esc(li.snapshot_meal_title || '') + ' × ' + (li.qty || 0) + ' @ ' + fmtMoney(li.snapshot_unit_price) + '</li>';
        });
        lines += '</ul>';
        var edit = !o.read_only && o.menu_permalink
            ? '<p class="md-order-detail-edit"><a class="btn btn-primary btn-sm" href="' + esc(o.menu_permalink) + '">Edit on menu</a></p>'
            : '';
        var warns = '';
        if (o.preference_warnings && o.preference_warnings.length) {
            warns += '<div class="md-warn">Preferences: ' +
                o.preference_warnings.map(function (w) { return esc(w.name); }).join(', ') + '</div>';
        }
        return (
            '<div class="md-order-detail">' +
            '<h2 class="md-order-detail__title">Order #' + o.id + '</h2>' +
            '<p class="md-order-detail__status">Status: <strong>' + esc(o.status) + '</strong> · ' + esc(o.fulfillment || '') +
            (o.payment_pill_html ? ' · ' + o.payment_pill_html : '') + '</p>' +
            warns +
            '<p class="md-order-detail__money">Subtotal ' + fmtMoney(o.subtotal) + ' · Tip ' + fmtMoney(o.tip_amount) +
            ' · <strong>Total ' + fmtMoney(o.total) + '</strong></p>' +
            lines +
            (o.customer_notes ? '<p class="md-order-detail__notes"><strong>Your notes:</strong> ' + esc(o.customer_notes) + '</p>' : '') +
            (o.snapshot_profile_customer_preferences ? '<p class="md-order-detail__snap"><strong>Preferences (at order):</strong> ' + esc(o.snapshot_profile_customer_preferences) + '</p>' : '') +
            edit +
            '<p><a href="' + esc(pathTo(0)) + '">← All orders</a></p>' +
            '</div>'
        );
    }

    var detailId = root.getAttribute('data-order-detail');
    detailId = detailId ? parseInt(detailId, 10) : 0;

    function load() {
        root.innerHTML = '<div class="md-profile-skeleton" aria-busy="true"><p>Loading…</p></div>';
        if (detailId > 0) {
            M.api('order/' + detailId, { method: 'GET' })
                .then(function (o) {
                    root.innerHTML = renderDetail(o);
                    root.setAttribute('aria-busy', 'false');
                })
                .catch(function (e) {
                    root.innerHTML = '<p class="md-error">' + esc(e.message || e) + '</p><p><button type="button" class="btn btn-primary-outline btn-sm md-orders-retry">Retry</button></p>';
                });
            return;
        }
        M.api('orders', { method: 'GET' })
            .then(function (data) {
                renderList(data.orders || [], 0);
            })
            .catch(function (e) {
                root.innerHTML = '<p class="md-error">' + esc(e.message || e) + '</p><p><button type="button" class="btn btn-primary-outline btn-sm md-orders-retry">Retry</button></p>';
            });
    }

    root.addEventListener('click', function (ev) {
        if (ev.target && ev.target.classList.contains('md-orders-retry')) {
            load();
        }
    });

    load();
})();
